<template>
  <figure class="payQrcode">
    <div
      class="qrcodeCard"
      ref="qrcodeCard"
      v-if="qrcodeData && qrcodeData.paymentMethod == 1"
    >
      <div class="qrcodeCard-content">
        <div class="qrcodeCard-name">{{ $t.meta.scanNotice1 }}</div>
      </div>
      <div class="qrcodeCard-image">
        <iframe
          :srcdoc="qrcodeData.linkUrl"
          frameborder="no"
          border="0"
          scrolling="no"
          width="300px"
          height="300px"
          style="overflow: hidden"
        >
        </iframe>
      </div>
    </div>

    <div
      class="qrcodeCard"
      ref="qrcodeCard"
      v-if="qrcodeData && qrcodeData.paymentMethod == 2"
    >
      <div class="qrcodeCard-content">
        <div class="qrcodeCard-name">{{ $t.meta.scanNotice2 }}</div>
      </div>
      <div class="qrcodeCard-image">
        <img style="width: 100%; height: 100%" :src="image" v-if="image" />
        <van-loading type="spinner" color="#ffffff" v-else />
      </div>
    </div>

    <div style="margin: 16px" v-if="qrcodeData && qrcodeData.paymentMethod == 2">
      <van-button round block type="info" @click="download">{{
        $t.meta.saveToAlbum
      }}</van-button>
    </div>
  </figure>
</template>
<script>
import Vue from "vue";
import { Loading, Image, Button } from "vant";
Vue.use(Loading).use(Image).use(Button);

import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import html2canvas from "html2canvas";

export default {
  name: "payQrcode",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      qrcodeData: null,
      image: "",
    };
  },
  mounted() {
    var data = JSON.parse(localStorage.getItem("payQrcode"));
    this.qrcodeData = data;
    if (this.qrcodeData && this.qrcodeData.paymentMethod == 2) {
      this.image = "data:image/png;base64," + this.qrcodeData.linkUrl;
    }
  },
  methods: {
    download() {
      let e = this.$refs.qrcodeCard;
      if (this.isApp) {
        html2canvas(e, {
          allowTaint: true,
          useCORS: true,
          tainttest: true,
          backgroundColor: null,
        }).then((canvas) => {
          Base64Image.save(
            canvas.toDataURL(),
            () => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: this.$t.meta.saveSuccess,
                type: "success",
              });
            },
            () => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: this.$t.meta.saveError,
                type: "error",
              });
            }
          );
        });
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
          element: e,
          successText: this.$t.meta.saveSuccess,
          failText: this.$t.meta.saveError,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.payQrcode {
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: inline-block;
  .qrcodeCard {
    margin: 20px;
    padding: 20px;
    background: linear-gradient(left, #009ed4, #5029c3);
    .qrcodeCard-content {
      width: 100%;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      .qrcodeCard-name {
        color: #ffffff;
        font-size: 12px;
      }
    }
    .qrcodeCard-image {
      text-align: center;
      width: 200px;
      height: 200px;
      margin: 20px auto;
      .image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        .van-image__error {
          position: relative;
        }
      }
      .image-error {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .van-loading {
        margin: auto;
        line-height: 250px;
      }
    }
  }
}
</style>
